function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6668 5.41667C11.6668 7.44171 10.0252 9.08333 8.00016 9.08333C5.97512 9.08333 4.3335 7.44171 4.3335 5.41667C4.3335 3.39162 5.97512 1.75 8.00016 1.75C10.0252 1.75 11.6668 3.39162 11.6668 5.41667Z",
  stroke: "currentColor",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00016 11.8333C4.45634 11.8333 1.5835 14.7062 1.5835 18.25H14.4168C14.4168 14.7062 11.544 11.8333 8.00016 11.8333Z",
  stroke: "currentColor",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgUserThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserThin);
export default __webpack_public_path__ + "static/media/user-thin.074a8c82.svg";
export { ForwardRef as ReactComponent };